import React from 'react';
import { Link } from 'react-router-dom';

function ExtraProducts() {
	return (
		<div>
			<div className="d-flex align-items-center mb-2">
							<div>
								<ul className="breadcrumb">
									<li className="breadcrumb-item"><a href="#/">Home</a></li>
									<li className="breadcrumb-item"><a href="#/">Extra</a></li>
									<li className="breadcrumb-item active"></li>
								</ul>
								<h1 className="page-header mb-0">Products</h1>
							</div>
							<div className="ms-auto">
								<a href="#/" className="btn btn-dark px-4"><i className="fa fa-plus fa-lg me-1 ms-n2 opacity-5"></i> Add Product</a>
							</div>
						</div>
						
						<div className="mb-3 d-md-flex gap-4 fw-bold py-1">
							<div className="mt-md-0 mt-2">
								<a href="#/" className="text-decoration-none d-flex align-items-center gap-2 link-dark">
									<iconify-icon icon="solar:download-linear" className="fs-4"></iconify-icon>
									Export
								</a>
							</div>
							<div className="mt-md-0 mt-2">
								<a href="#/" className="text-decoration-none d-flex align-items-center gap-2 link-dark">
									<iconify-icon icon="solar:upload-linear" className="fs-4"></iconify-icon>
									Import
								</a>
							</div>
							<div className="mt-md-0 mt-2 d-flex align-items-center gap-2 dropdown-toggle">
								<a href="#/" data-bs-toggle="dropdown" className="d-flex align-items-center gap-2 link-dark text-decoration-none">
									<iconify-icon icon="solar:settings-linear" className="fs-4"></iconify-icon>
									More Actions
									<b className="caret ms-0"></b>
								</a>
								<div className="dropdown-menu">
									<a className="dropdown-item" href="#/">Action</a>
									<a className="dropdown-item" href="#/">Another action</a>
									<a className="dropdown-item" href="#/">Something else here</a>
									<div role="separator" className="dropdown-divider"></div>
									<a className="dropdown-item" href="#/">Separated link</a>
								</div>
							</div>
						</div>
						
						
						<div className="card border-0 rounded-3">
							<div className="mx-3 overflow-x-scroll">
								<ul className="nav nav-tabs nav-tabs-v2 gap-3 fs-6 flex-nowrap text-nowrap w-100">
									<li className="nav-item m-0"><a href="#/" className="nav-link px-2 py-32 active d-flex align-items-center gap-2" data-bs-toggle="tab">All</a></li>
									<li className="nav-item m-0"><a href="#/" className="nav-link px-2 py-32 d-flex align-items-center gap-2" data-bs-toggle="tab">Published</a></li>
									<li className="nav-item m-0"><a href="#/" className="nav-link px-2 py-32 d-flex align-items-center gap-2" data-bs-toggle="tab">Expired</a></li>
									<li className="nav-item m-0"><a href="#/" className="nav-link px-2 py-32 d-flex align-items-center gap-2" data-bs-toggle="tab">Deleted</a></li>
								</ul>
							</div>
							<div className="tab-content p-3">
								<div className="tab-pane fade show active">
									
									<div className="row gx-2 gy-2 align-items-center mb-2">
										<div className="col-xl-7">
											<div className="d-flex gap-2">
												<button className="btn btn-white d-flex align-items-center gap-2 text-ellipsis mb-md-0 mb-2">
													<iconify-icon icon="solar:list-arrow-down-linear" className="fs-4 opacity-5"></iconify-icon> 
													Most relevant
													<b className="caret ms-auto"></b>
												</button>
												<div className="flex-1 position-relative">
													<i className="fa fa-search position-absolute top-50 start-0 translate-middle-y text-muted ms-3"></i>
													<input type="text" className="form-control ps-5" placeholder="Search products..." />
													<a href="#/" className="btn btn-sm rounded-pill position-absolute end-0 top-0 bottom-0 d-flex align-items-center link-secondary opacity-5 fs-6 py-0"><i className="fa fa-times-circle fa-lg"></i></a>
												</div>
											</div>
										</div>
										<div className="col-xl-5">
											<div className="row gx-2 gy-2">
												<div className="col-xl-4 col-lg-3 col-sm-4 col-6">
													<select className="form-select">
														<option value="">All Type</option>
														<option>Phone</option>
														<option>Laptop</option>
														<option>Desktop</option>
														<option>Watch</option>
													</select>
												</div>
												<div className="col-xl-4 col-lg-3 col-sm-4 col-6">
													<select className="form-select">
														<option value="">All Vendor</option>
														<option>Machine</option>
														<option>Mac City</option>
														<option>Switch</option>
														<option>iMagic</option>
													</select>
												</div>
												<div className="col-xl-4 col-lg-3 col-sm-4">
													<button className="btn btn-primary w-100">Search</button>
												</div>
											</div>
										</div>
									</div>
									
									
									<div className="table-responsive mb-3">
										<table className="table table-hover table-card table-py-8px text-nowrap align-middle mb-0">
											<thead>
												<tr>
													<th className="pt-0 pb-2"></th>
													<th className="pt-0 pb-2">Product</th>
													<th className="pt-0 pb-2">Inventory</th>
													<th className="pt-0 pb-2">Type</th>
													<th className="pt-0 pb-2">Vendor</th>
												</tr>
											</thead>
											<tbody>
												<tr>
													<td className="w-10px align-middle">
														<div className="form-check">
															<input type="checkbox" className="form-check-input" id="product1" />
															<label className="form-check-label" htmlFor="product1"></label>
														</div>
													</td>
													<td>
														<div className="d-flex align-items-center gap-3">
															<img alt="" className="w-50px h-50px object-fit-cover rounded-3" src="/color-admin/admin/react/assets/img/product/iphone-17-pro-max.jpg" />
															<div className="flex-1">
																<Link to="/page/product-details" className="fw-bold link-dark text-decoration-none">iPhone 17 Pro Max</Link>
															</div>
														</div>
													</td>
													<td className="align-middle">83 in stock for 3 variants</td>
													<td className="align-middle">Phone</td>
													<td className="align-middle">Machine</td>
												</tr>
												<tr>
													<td className="w-10px align-middle">
														<div className="form-check">
															<input type="checkbox" className="form-check-input" id="product2" />
															<label className="form-check-label" htmlFor="product2"></label>
														</div>
													</td>
													<td>
														<div className="d-flex align-items-center gap-3">
															<img alt="" className="w-50px h-50px object-fit-cover rounded-3" src="/color-admin/admin/react/assets/img/product/iphone-17.jpg" />
															<div className="flex-1">
																<Link to="/page/product-details" className="fw-bold link-dark text-decoration-none">iPhone 17</Link>
															</div>
														</div>
													</td>
													<td className="align-middle">79 in stock for 3 variants</td>
													<td className="align-middle">Phone</td>
													<td className="align-middle">Machine</td>
												</tr>
												<tr>
													<td className="w-10px align-middle">
														<div className="form-check">
															<input type="checkbox" className="form-check-input" id="product3" />
															<label className="form-check-label" htmlFor="product3"></label>
														</div>
													</td>
													<td>
														<div className="d-flex align-items-center gap-3">
															<img alt="" className="w-50px h-50px object-fit-cover rounded-3" src="/color-admin/admin/react/assets/img/product/iphone-air.jpg" />
															<div className="flex-1">
																<Link to="/page/product-details" className="fw-bold link-dark text-decoration-none">iPhone Air</Link>
															</div>
														</div>
													</td>
													<td className="align-middle">19 in stock for 1 variants</td>
													<td className="align-middle">Phone</td>
													<td className="align-middle">Machine</td>
												</tr>
												<tr>
													<td className="w-10px align-middle">
														<div className="form-check">
															<input type="checkbox" className="form-check-input" id="product4" />
															<label className="form-check-label" htmlFor="product4"></label>
														</div>
													</td>
													<td>
														<div className="d-flex align-items-center gap-3">
															<img alt="" className="w-50px h-50px object-fit-cover rounded-3" src="/color-admin/admin/react/assets/img/product/iphone-16.jpg" />
															<div className="flex-1">
																<Link to="/page/product-details" className="fw-bold link-dark text-decoration-none">iPhone 16</Link>
															</div>
														</div>
													</td>
													<td className="align-middle">19 in stock for 1 variants</td>
													<td className="align-middle">Phone</td>
													<td className="align-middle">Machine</td>
												</tr>
												<tr>
													<td className="w-10px align-middle">
														<div className="form-check">
															<input type="checkbox" className="form-check-input" id="product5" />
															<label className="form-check-label" htmlFor="product5"></label>
														</div>
													</td>
													<td>
														<div className="d-flex align-items-center gap-3">
															<img alt="" className="w-50px h-50px object-fit-cover rounded-3" src="/color-admin/admin/react/assets/img/product/iphone-16e.jpg" />
															<div className="flex-1">
																<Link to="/page/product-details" className="fw-bold link-dark text-decoration-none">iPhone 16e</Link>
															</div>
														</div>
													</td>
													<td className="align-middle">19 in stock for 1 variants</td>
													<td className="align-middle">Phone</td>
													<td className="align-middle">Machine</td>
												</tr>
												<tr>
													<td className="w-10px align-middle">
														<div className="form-check">
															<input type="checkbox" className="form-check-input" id="product6" />
															<label className="form-check-label" htmlFor="product6"></label>
														</div>
													</td>
													<td>
														<div className="d-flex align-items-center gap-3">
															<img alt="" className="w-50px h-50px object-fit-cover rounded-3" src="/color-admin/admin/react/assets/img/product/ipad-pro.jpg" />
															<div className="flex-1">
																<Link to="/page/product-details" className="fw-bold link-dark text-decoration-none">iPad Pro</Link>
															</div>
														</div>
													</td>
													<td className="align-middle">30 in stock for 4 variants</td>
													<td className="align-middle">Tablet</td>
													<td className="align-middle">Machine</td>
												</tr>
												<tr>
													<td className="w-10px align-middle">
														<div className="form-check">
															<input type="checkbox" className="form-check-input" id="product7" />
															<label className="form-check-label" htmlFor="product7"></label>
														</div>
													</td>
													<td>
														<div className="d-flex align-items-center gap-3">
															<img alt="" className="w-50px h-50px object-fit-cover rounded-3" src="/color-admin/admin/react/assets/img/product/ipad.jpg" />
															<div className="flex-1">
																<Link to="/page/product-details" className="fw-bold link-dark text-decoration-none">iPad</Link>
															</div>
														</div>
													</td>
													<td className="align-middle">49 in stock for 8 variants</td>
													<td className="align-middle">Tablet</td>
													<td className="align-middle">Machine</td>
												</tr>
												<tr>
													<td className="w-10px align-middle">
														<div className="form-check">
															<input type="checkbox" className="form-check-input" id="product8" />
															<label className="form-check-label" htmlFor="product8"></label>
														</div>
													</td>
													<td>
														<div className="d-flex align-items-center gap-3">
															<img alt="" className="w-50px h-50px object-fit-cover rounded-3" src="/color-admin/admin/react/assets/img/product/ipad-mini.jpg" />
															<div className="flex-1">
																<Link to="/page/product-details" className="fw-bold link-dark text-decoration-none">iPad Mini</Link>
															</div>
														</div>
													</td>
													<td className="align-middle">19 in stock for 1 variants</td>
													<td className="align-middle">Tablet</td>
													<td className="align-middle">Machine</td>
												</tr>
												<tr>
													<td className="w-10px align-middle">
														<div className="form-check">
															<input type="checkbox" className="form-check-input" id="product9" />
															<label className="form-check-label" htmlFor="product9"></label>
														</div>
													</td>
													<td>
														<div className="d-flex align-items-center gap-3">
															<img alt="" className="w-50px h-50px object-fit-cover rounded-3" src="/color-admin/admin/react/assets/img/product/apple-watch-ultra-3.jpg" />
															<div className="flex-1">
																<Link to="/page/product-details" className="fw-bold link-dark text-decoration-none">Apple Watch Ultra 3</Link>
															</div>
														</div>
													</td>
													<td className="align-middle">94 in stock for 1 variants</td>
													<td className="align-middle">Watch</td>
													<td className="align-middle">Machine</td>
												</tr>
												<tr>
													<td className="w-10px align-middle">
														<div className="form-check">
															<input type="checkbox" className="form-check-input" id="product10" />
															<label className="form-check-label" htmlFor="product10"></label>
														</div>
													</td>
													<td>
														<div className="d-flex align-items-center gap-3">
															<img alt="" className="w-50px h-50px object-fit-cover rounded-3" src="/color-admin/admin/react/assets/img/product/apple-watch-series-11.jpg" />
															<div className="flex-1">
																<Link to="/page/product-details" className="fw-bold link-dark text-decoration-none">Apple Watch Series 11</Link>
															</div>
														</div>
													</td>
													<td className="align-middle">23 in stock for 5 variants</td>
													<td className="align-middle">Watch</td>
													<td className="align-middle">Machine</td>
												</tr>
											</tbody>
										</table>
									</div>
									
									
									<div className="d-md-flex align-items-center">
										<div className="me-md-auto text-md-left text-center mb-2 mb-md-0 fw-semibold text-secondary">
											Showing 1 to 10 of 57 entries
										</div>
										<ul className="pagination mb-0 justify-content-center">
											<li className="page-item disabled"><a className="page-link" href="#/">«</a></li>
										<li className="page-item disabled"><a className="page-link" href="#/">Prev</a></li>
											<li className="page-item"><a className="page-link" href="#/">1</a></li>
											<li className="page-item active"><a className="page-link" href="#/">2</a></li>
											<li className="page-item"><a className="page-link" href="#/">3</a></li>
											<li className="page-item"><a className="page-link" href="#/">4</a></li>
											<li className="page-item"><a className="page-link" href="#/">5</a></li>
											<li className="page-item"><a className="page-link" href="#/">Next</a></li>
											<li className="page-item"><a className="page-link" href="#/">»</a></li>
										</ul>
									</div>
								</div>
							</div>
						</div>
		</div>
	);
}

export default ExtraProducts;
